import { render, staticRenderFns } from "./RestoreModal.vue?vue&type=template&id=4dfe398e&scoped=true&"
import script from "./RestoreModal.vue?vue&type=script&lang=js&"
export * from "./RestoreModal.vue?vue&type=script&lang=js&"
import style0 from "./RestoreModal.vue?vue&type=style&index=0&id=4dfe398e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe398e",
  null
  
)

export default component.exports